module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?e971abae304374a81d9f7cea55039de8";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.eot?v=4.5.95
// module id = y4R0
// module chunks = 1